<template>
    <mdb-container>
        <Vedheader></Vedheader>
        <Adminheader></Adminheader>
        <mdb-row class="mt-2">
            <mdb-col>
                <mdb-btn color="primary" v-on:click="golistusers"><mdb-icon icon="chevron-left" class="mr-1"/> Retour à la liste des utilisateurs</mdb-btn>
            </mdb-col>
        </mdb-row>
        <mdb-card class="card-body" style="margin-top: 1rem;" v-if="isLoading">
            <div class="d-flex justify-content-center">
                <mdb-spinner big color="blue" />
            </div>
        </mdb-card>
        <mdb-row v-if="!isLoading">
            <mdb-col>
                <mdb-card class="mt-2" cascade narrow>
                    <mdb-card-header cascade class="text-center">
                        <h5 class="mb-0 font-weight-bold">{{userinfos.firstname}} {{userinfos.lastname}}</h5>
                    </mdb-card-header>
                    <mdb-card-body cascade>
                        <mdb-card>
                            <mdb-card-body>
                                <mdb-row>
                                    <mdb-col>
                                        <h4>Informations générales</h4><h5>Lecture seulement</h5>
                                    </mdb-col>
                                </mdb-row>
                                <mdb-row>
                                    <mdb-col md="4">
                                        <mdb-input label="Téléphone" disabled="disabled" v-model="userinfos.phone" />
                                    </mdb-col>
                                    <mdb-col md="4">
                                        <mdb-input label="CCV" disabled="disabled" v-model="userinfos.ccv" />
                                    </mdb-col>
                                    <mdb-col md="4">
                                        <mdb-input label="Agence" disabled="disabled" v-model="userinfos.agency" />
                                    </mdb-col>
                                </mdb-row>
                                <mdb-row>
                                    <mdb-col md="4">
                                        <mdb-input label="Adresse postale" disabled="disabled" v-model="userinfos.address" />
                                    </mdb-col>
                                    <mdb-col md="4">
                                        <mdb-input label="Ville" disabled="disabled" v-model="userinfos.city" />
                                    </mdb-col>
                                    <mdb-col md="4">
                                        <mdb-input label="Code postal" disabled="disabled" v-model="userinfos.postalcode" />
                                    </mdb-col>
                                </mdb-row>
                            </mdb-card-body>
                        </mdb-card>

                        <mdb-card class="mt-4">
                            <mdb-card-body>
                                <mdb-row>
                                    <mdb-col>
                                        <h4>Statistiques d'écoute</h4>
                                    </mdb-col>
                                </mdb-row>

                                <mdb-row>
                                    <mdb-col>
                                        <mdb-tbl>
                                            <mdb-tbl-body>
                                                <tr>
                                                    <td class="w-25"><strong>Heures d'écoute</strong></td>
                                                    <td>{{userinfos.nbminutesviewed}}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Nombre de formations débutées</strong></td>
                                                    <td>{{userinfos.nbvideosstarted}}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Nombre de formations complétées</strong></td>
                                                    <td>{{userinfos.nbvideoscompleted}}</td>
                                                </tr>
                                            </mdb-tbl-body>
                                        </mdb-tbl>
                                    </mdb-col>
                                </mdb-row>
                            </mdb-card-body>
                        </mdb-card>

                        <mdb-card class="mt-4">
                            <mdb-card-body>
                                <mdb-row>
                                    <mdb-col>
                                        <h4>Informations modifiable</h4>
                                    </mdb-col>
                                </mdb-row>
                                <mdb-alert color="danger" v-if="error" class="mt-3">
                                    {{ error }}
                                </mdb-alert>
                                <mdb-alert color="success" v-if="success" class="mt-3">
                                    {{ success }}
                                </mdb-alert>
                                <mdb-row>
                                    <mdb-col md="4">
                                        <mdb-input label="Nouveau mot de passe" type="password" v-model="newpassword" />
                                    </mdb-col>
                                </mdb-row>
                                <mdb-row>
                                    <mdb-col md="4">
                                        <mdb-input type="checkbox" id="chkccvneeded" v-model="userinfos.ccvneeded" label="CCV requis" />
                                    </mdb-col>

                                </mdb-row>
                                <div class="text-left mt-3">
                                    <mdb-btn v-on:click="updateuser">Enregistrer</mdb-btn>
                                </div>
                            </mdb-card-body>
                        </mdb-card>

                    </mdb-card-body>
                </mdb-card>
            </mdb-col>
        </mdb-row>
        <mdb-footer color="mdb-color" class="font-small lighten-3 pt-4 mt-4 mt-5">
            <div class="footer-copyright text-center py-3">
                <mdb-container fluid>
                    &copy; 2020 Copyright: <a href="https://expertenvoyages.com/"> Expert En Voyage </a>
                </mdb-container>
            </div>
        </mdb-footer>
    </mdb-container>
</template>

<script>
    import Vedheader from '@/components/Header.vue';
    import Adminheader from '@/components/Adminheader.vue';
    import {
        mdbContainer,
        mdbAlert,
        mdbRow,
        mdbCol,
        mdbInput,
        mdbFooter,
        mdbCard,
        mdbCardHeader,
        mdbBtn,
        mdbCardBody,
        mdbTbl,
        mdbTblBody,
        mdbSpinner,
        mdbIcon,
    } from 'mdbvue';
    import Apicall from '../libs/Apicall';

    export default {
        name: 'Adminviewuser',
        components: {
            Vedheader,
            mdbAlert,
            mdbContainer,
            mdbCol,
            mdbRow,
            Adminheader,
            mdbInput,
            mdbFooter,
            mdbCard,
            mdbCardHeader,
            mdbBtn,
            mdbCardBody,
            mdbTbl,
            mdbTblBody,
            mdbSpinner,
            mdbIcon,
        },
        data() {
            return {
                error: null,
                success: null,
                newpassword: '',
                userinfos: {},
                isLoading: true,
            };
        },
        mounted() {
            this.getAndDisplayUser();
        },
        methods: {
            getAndDisplayUser() {
                const api = new Apicall();
                const self = this;
                api.getUser(this.$route.params.usersystemid).then((response) => {
                    if (response.status === 'OK') {
                        self.userinfos = response.data.userinfos;
                        self.isLoading = false;
                    }
                });
            },
            updateuser() {
                const api = new Apicall();
                const self = this;
                api.updateUser(this.$route.params.usersystemid, this.newpassword, this.userinfos).then((response) => {
                    self.newpassword = null;
                    if (response.status === 'OK') {
                        self.success = 'Les informations ont été mises à jour';
                    } else {
                        self.error = response.msg;
                    }
                });
            },
            golistusers() {
                this.$router.push({ name: 'Adminuser' });
            },
        },
    };
</script>
